import { Controller } from "@hotwired/stimulus"

// ManualDocsDialog di pages/Grants.js: «Carica moduli» apre la scelta dei file, la scelta li invia subito (onFiles);
// durante l'invio il pulsante è fermo con la rotella (uploading) e alla fine, riuscito o no, l'input torna vuoto
// (finally: fileRef.current.value = "").
export default class extends Controller {
  static targets = ["form", "input"]

  scegli() {
    if (this.element.getAttribute("aria-busy") === "true") return
    this.inputTarget.click()
  }

  invia() {
    if (this.inputTarget.files.length) this.formTarget.requestSubmit()
  }

  inizio(event) {
    if (event.target === this.formTarget) this.element.setAttribute("aria-busy", "true")
  }

  fine(event) {
    if (event.target !== this.formTarget) return
    this.element.removeAttribute("aria-busy")
    this.inputTarget.value = ""
  }
}
